// extracted by mini-css-extract-plugin
module.exports = {"Support":"D_Support__WSfx4"};